var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreencircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7279 7.50016C14.7279 3.81961 11.7418 0.833496 8.0612 0.833496C4.38064 0.833496 1.39453 3.81961 1.39453 7.50016C1.39453 11.1807 4.38064 14.1668 8.0612 14.1668C11.7418 14.1668 14.7279 11.1807 14.7279 7.50016Z",
    fill: "#16A34A",
    stroke: "#16A34A",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3932 4.72241L6.72656 10.278L4.72656 8.05574",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreencircle);
export default __webpack_public_path__ + "static/media/tick_greencircle.a5e915c9c7cfdd1807ff5751ad09c2a7.svg";
export { ForwardRef as ReactComponent };